<section class="oauth-consent" aria-labelledby="oauth-consent-title">
  <header class="oauth-consent__header">
    <h1 id="oauth-consent-title" class="oauth-consent__title">
      {{ partnerLabel() }}
      {{ 'app.identity.oauthConsent.titleSuffix' | translate }}
    </h1>
    <p class="oauth-consent__subtitle">
      {{ 'app.identity.oauthConsent.subtitle' | translate }}
    </p>
  </header>

  @if (pageError()) {
    <app-info-banner
      class="oauth-consent__banner"
      variant="warning"
      [title]="'app.identity.oauthConsent.errors.title'"
      [message]="pageError()!"
      [translateTitle]="true"
      [translateMessage]="false"
    />
  }

  @if (loading()) {
    <p class="oauth-consent__loading">
      {{ 'app.identity.oauthConsent.loading' | translate }}
    </p>
  } @else if (!pageError()) {
    <article class="oauth-consent__partner">
      <p class="oauth-consent__meta">
        {{ 'app.identity.oauthConsent.appId' | translate }}:
        <code>{{ clientId() }}</code>
        @if (environment() === 'sandbox') {
          <span class="oauth-consent__badge">
            {{ 'app.identity.oauthConsent.sandboxBadge' | translate }}
          </span>
        }
      </p>

      <section class="oauth-consent__scopes">
        <h2 class="oauth-consent__scopes-title">
          {{ 'app.identity.oauthConsent.scopesTitle' | translate }}
        </h2>
        <ul class="oauth-consent__scope-list">
          @for (scopeId of scopeIds(); track scopeId) {
            <li>{{ scopeLabel(scopeId) }}</li>
          }
        </ul>
        <p class="oauth-consent__scopes-note">
          {{ 'app.identity.oauthConsent.scopesNote' | translate }}
        </p>
      </section>

      <footer class="oauth-consent__actions">
        <app-parent-button
          variant="ghost"
          [disabled]="confirming()"
          (clicked)="cancel()"
        >
          {{ 'app.identity.oauthConsent.cancel' | translate }}
        </app-parent-button>
        <app-parent-button
          variant="primary"
          [disabled]="!canAuthorize() || confirming()"
          [loading]="confirming()"
          (clicked)="continueToPartner()"
        >
          {{ 'app.identity.oauthConsent.continue' | translate }}
        </app-parent-button>
      </footer>
    </article>
  }
</section>
